/* eslint-disable no-unused-vars */
import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import useTranslation from 'next-translate/useTranslation'
import { Button, Col, Row } from 'react-bootstrap'

import useWindowSize from '@shared/hooks/windowSize'
import Stories from '@shared/components/stories'
import { allRoutes } from '@shared/constants/allRoutes'
import Link from 'next/link'

const Slider = dynamic(() => import('@shared-components/slider'))
const CustomLink = dynamic(() => import('@shared/components/customLink'))
// const StoriesLightBox = dynamic(() => import('@shared/components/stories/stories-light-box'))

const HomePageStories = ({ stories }) => {
  const { t } = useTranslation()
  const [width] = useWindowSize()
  // console.log(stories, 'stories')

  if (stories?.length) {
    return (
      <section className="">
        {/* <StoriesLightBox data={stories} /> */}
        <h4 className="line-title mb-2 mb-md-3 mt-4 text-uppercase overflow-hidden">
          <span className="position-relative d-inline-block text-nowrap t-ellipsis ms-0 ms-sm-4 ms-lg-5">{t('Web Stories')}</span>
        </h4>
        <Slider gap={10} nav={width > 1199} destroyBelow={1199} navClass="mx-3" id="enable-stories-player">
          {stories?.map((data, index) => (
            <div key={data?._id}>
              <Stories data={data} />
            </div>
          ))}
        </Slider>
        <Row className="justify-content-center mt-3 mt-md-3">
          <Col xl={7} sm={7}>
            <CustomLink href={allRoutes.webStories}>
              <Button variant="danger" className='w-100'>
                {t('ViewMore')} {t('Stories')} &gt;
              </Button>
            </CustomLink>
          </Col>
        </Row>
      </section>
    )
  } else return null
}
HomePageStories.propTypes = {
  stories: PropTypes.array
}
export default HomePageStories
